/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuAvatar, NeuImage } from '@neutron/react';

export const AvatarContainer = styled(NeuAvatar)`
  margin-right: 0.5rem;
`;

export const EmployeeInfoContainer = styled.div`
  display: flex;
`;

export const EmployeeAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const StartDateContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  position: relative;
`;

export const IconDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 0.5rem;
  width: 22px;
`;

export const OnShiftIcon = styled(NeuImage)`
  width: 1.25rem;
`;
